import { InputSchema, groupInput, input } from "@redotech/ui/form";
import { nonEmptyValidator } from "@redotech/ui/validators";
import { memo } from "react";
import { RedoTextInput } from "../../../../arbiter-components/input/redo-text-input";
import { Flex } from "../../../../flex";

export const PurolatorCarrierInput = groupInput({
  accountNumber: input<string>({ validator: nonEmptyValidator }),
  productionApiKey: input<string>({ validator: nonEmptyValidator }),
  productionApiKeyPassword: input<string>({ validator: nonEmptyValidator }),
});

export type PurolatorCarrierValue = InputSchema.Value<
  typeof PurolatorCarrierInput
>;

export type PurolatorCarrierForm = InputSchema.Input<
  typeof PurolatorCarrierInput
>;

export const purolatorCarrierDefault = (): PurolatorCarrierValue => ({
  accountNumber: "",
  productionApiKey: "",
  productionApiKeyPassword: "",
});

export const CreatePurolatorCarrierForm = memo(
  function CreatePurolatorCarrierForm({
    carrierInput,
  }: {
    carrierInput: PurolatorCarrierForm;
  }) {
    return (
      <Flex dir="column">
        <RedoTextInput
          label="Account Number"
          placeholder=""
          setValue={carrierInput.inputs.accountNumber.setValue}
          value={carrierInput.inputs.accountNumber.value}
        />
        <RedoTextInput
          label="Production API Key"
          placeholder=""
          setValue={carrierInput.inputs.productionApiKey.setValue}
          value={carrierInput.inputs.productionApiKey.value}
        />
        <RedoTextInput
          label="Production API Key Password"
          placeholder=""
          setValue={carrierInput.inputs.productionApiKeyPassword.setValue}
          value={carrierInput.inputs.productionApiKeyPassword.value}
        />
      </Flex>
    );
  },
);
